var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { CardTimestamp } from "./CardTimestamp";
import { ShareArea } from "./ShareArea";
import { useIsMobileContext } from "../../contexts";
export var CardFooter = function (props) {
    var brightText = props.brightText, createdAt = props.createdAt, hideShareButton = props.hideShareButton, shareUrl = props.shareUrl;
    var isMobile = useIsMobileContext();
    var _a = useState(3), margin = _a[0], setMargin = _a[1];
    useEffect(function () {
        setMargin(isMobile ? 2 : 3);
    }, [isMobile]);
    return (_jsxs(Stack, __assign({ sx: {
            ml: margin,
            mb: margin,
            flexGrow: 0,
            mr: margin,
            zIndex: 1,
        }, direction: "row", justifyContent: "space-between", alignItems: "flex-end" }, { children: [createdAt && _jsx(CardTimestamp, { date: createdAt, brightText: brightText }), !hideShareButton && shareUrl && _jsx(ShareArea, { shareUrl: shareUrl, brightText: brightText })] })));
};
